/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Button } from '@material-ui/core'

import { v4 as uuidv4 } from 'uuid';

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({})


class LinkedScreen extends Component {
    state = {
        url : null,
        unsafe_http : false,
        query_params : [],
        iframe_key : "0"
    }

    componentDidMount () {
        let params = this.loadDefaultParams()
        this.setState({...this.state, url : params.url, unsafe_http : params.unsafe_http, query_params : params.query_params})
    }

    componentDidUpdate (prevProps, prevState) {
        let prev_query_params = JSON.stringify(prevProps.query_params)
        let cur_query_params = JSON.stringify(this.props.query_params)

        if (cur_query_params !==  prev_query_params) {
            let params = this.loadDefaultParams()
            this.setState({...this.state, url : params.url, unsafe_http : params.unsafe_http, query_params : params.query_params}, () => this.generateRandomKey())
        }
    }

    loadDefaultParams = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let screen
        if (this.props.embedded) {
            screen = this.props.config
        } else {
            screen = links_section.screens.find(route => route.route === this.props.location.pathname)
        }
        let params = screen.default_params

        if (this.props.query_params) {
            this.props.query_params.map((param) => {
                if(param.default_value !== "") {
                    let index = params.query_params.findIndex((query_param) => query_param.key === param.key)
                    params.query_params[index].default_value = param.default_value
                }
            })
        }

        console.log("Default Params in Config : ", params)
        let params_with_values = params !== null ? Object.entries(params).filter(entry => entry[1] !== null) : []
        return Object.fromEntries(params_with_values) 
    }

    getScreenName = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes')).drawer
        let links_section = routes.find(section => section.id === 'links')
        let screen
        if (this.props.embedded) {
            screen = this.props.config
        } else {
            screen = links_section.screens.find(route => route.route === this.props.location.pathname)
        }
        return screen.name
    }

    getSource = () => {
        if (this.state.unsafe_http) {
            console.log("Rerouting SRC : ", window.location.origin + "/#/proxy-screen?showAppbar=false&uri=" + encodeURIComponent(this.state.url))
            return window.location.origin + "/#/proxy-screen?showAppbar=false&reroute=" + encodeURIComponent(this.state.url)
        } else {
            if (this.state.query_params.length > 0) {
                let query_params = this.state.query_params.map(qp => [qp.key, encodeURIComponent(qp.default_value)])
                query_params = query_params.map(qp => qp.join("="))
                query_params = query_params.length > 1 ? query_params.join("&") : query_params.join()
                let source_url = 'https://' + this.state.url + "?" + query_params
                return source_url
            } else {
                return 'https://' + this.state.url
            }
        }
    }

    generateRandomKey = () => {
        let random_key = uuidv4()
        this.setState({...this.state, iframe_key : random_key})
    }

    renderIframe = () => {
        if (this.state.url !== null) {
            return (
                <iframe key = {this.state.iframe_key} title = {this.getScreenName()} width = '100%' height = '98%' src={this.getSource()}></iframe>
            )
        }
    }

    openInNewTab = () => {
        window.open(this.getSource(), "_blank")
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div
                    style = {{
                        width : this.props.width ? this.props.width : '100vw',
                        height : this.props.height ? this.props.height : 'calc(100vh - 50px)',
                        display : 'flex',
                        flexDirection : 'column'
                    }}
                >
                    <Paper 
                        square
                        style = {{
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            padding : '5px'
                        }}
                    >
                        <div style = {{display : "flex", flexDirection : 'row', alignItems : 'center', flexGrow : 1}}>
                            <Typography variant='button' color = 'textPrimary'>{this.getScreenName()}</Typography>
                        </div>
                        <Button
                            style = {{marginRight : '10px'}}
                            size = 'small'
                            color = 'primary'
                            onClick = {() => this.generateRandomKey()}
                        >Home</Button>
                        <Button variant = 'contained' size = 'small' color = 'primary' onClick={this.openInNewTab}>Open In New Tab</Button>
                    </Paper>
                    <div style = {{width : '100%', flexGrow : 1}}>
                        {this.renderIframe()}
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(LinkedScreen);